import * as React from "react";
import OpQuotesTwoColData from "./opQuotesTwoColData";
import DeviceContext from "../../../../service/indentifyDevice";
import { IOpLabelValue } from "../../../../types/components/orderPlacement/opTypes";
import { useRouteMatch } from "react-router-dom";
import { toINR } from "../../../../service/numberFormat";

export interface IOpMarketDepthTableProps {
	open?: string;
	volume?: string;
	high?: string;
	low?: string;
	tBidQty?: string;
	tAskQty?: string;
	ask?: Array<any>;
	bid?: Array<any>;
	spot?: string;
	opInt?: string;
	opIntChgP?: string;
	hiCt?: string;
	loCt?: string;
	ltSz?: string;
	bidivfut?: string;
	mns?: string;
}

const OpMarketDepthTable: React.FC<IOpMarketDepthTableProps> = props => {
	const futOpt = useRouteMatch().url.split("/")[3];

	const lastSectionData: Array<IOpLabelValue> = [];

	// push all the available values in last section data
	props.bidivfut && lastSectionData.push({ label: "Implied Volatility", value: `₹${props.bidivfut}` });
	props.mns && lastSectionData.push({ label: "Moneyness", value: props.mns });
	props.hiCt && lastSectionData.push({ label: "High Circuit Limit", value: `₹${props.hiCt}` });
	props.loCt && lastSectionData.push({ label: "Low Circuit Limit", value: `₹${props.loCt}` });
	props.ltSz && lastSectionData.push({ label: "Lot Size", value: props.ltSz });

	return (
		<div className="op_market_depth_table">
			{props.spot && (
				<div className={"mg-b15" + (DeviceContext().isDesktop ? " mg-t15" : "")}>
					<div className="label">{futOpt === "future" ? "Spot" : "Future"} Price</div>
					<div className="value">
						{toINR(props.spot)} <span className="green">2441.12 (12.23%)</span>
					</div>
				</div>
			)}

			{props.spot && <div className="divider" />}

			<div className="mg-t15 mg-b2">
				<OpQuotesTwoColData
					data={[
						{ label: "Open", value: toINR(props.open) },
						{ label: "Volume", value: toINR(props.volume) },
						{ label: "High", value: toINR(props.high) },
						{ label: "Low", value: toINR(props.low) }
					]}
				></OpQuotesTwoColData>
			</div>

			<div className="divider" />

			{props.ask && (
				<div className="mg-t15 mg-b15 bid_table">
					<ul className="heading label">
						<li className="ib col1">Ord#</li>
						<li className="ib col2">Bid Price (Qty)</li>
						<li className="ib col3">Ask Price (Qty)</li>
						<li className="ib col4">Ord#</li>
					</ul>
					{props.ask.map((a, index) => (
						<ul className="body" key={index}>
							<li className="ib col1">{props.bid![index].no}</li>
							<li className="ib col2">
								{toINR(props.bid![index].price)} ({props.bid![index].qty})
							</li>
							<li className="ib col3">
								{toINR(a.price)} ({a.qty})
							</li>
							<li className="ib col4">{a.no}</li>
						</ul>
					))}
				</div>
			)}

			<div className="divider" />

			<div className="mg-t15 mg-b2">
				<div className="ib t_bid label">T. Bid Qty</div>
				<div className="ib t_bid value">{toINR(props.tBidQty)}</div>
				<div className="ib t_ask label">T. Ask Qty</div>
				<div className="ib t_ask value">{toINR(props.tAskQty)}</div>
			</div>

			{props.opInt && <div className="divider" />}

			{props.opInt && (
				<div className="mg-t15 mg-b2">
					<OpQuotesTwoColData
						data={[
							{ label: "OI (Lacs)", value: props.opInt },
							{ label: "Change in O/I (%)", value: props.opIntChgP! }
						]}
					></OpQuotesTwoColData>
				</div>
			)}

			{lastSectionData.length > 0 && <div className="divider" />}

			{lastSectionData.length > 0 && (
				<div className="mg-t15">
					<OpQuotesTwoColData data={lastSectionData}></OpQuotesTwoColData>
				</div>
			)}
		</div>
	);
};

export default OpMarketDepthTable;
